import React from "react";

interface OcrReviewFlagProps {
  confidence?: number | null;
}

export default function OcrReviewFlag({ confidence }: OcrReviewFlagProps) {
  if (confidence === null || confidence === undefined) return null;
  if (Math.round(Number(confidence) * 100) >= 75) return null;

  return <span className="ml-2 text-xs text-amber-600">Review</span>;
}
